<template>
    <div class="container">
        <visualizadorestoque :idproduto="idprodutoestoque" :descricao="descproestoque"></visualizadorestoque>
        <div id="dvimagensprodutosve" class="row" style="display: none;">
            <div class="col-md-12">
                <viewer :images="images" rebuild class="viewer">
                    <img v-for="src in images" :key="src" :src="src">
                </viewer>                            
            </div>
        </div>        
        <div id="dvinicialvendaexterna" class="row align-items-center" style="margin-top: -15px;">
            <div class="col-12 col-md-2 col-lg-3 col-xl-3">
            </div>        
            <div class="col-12 col-md-8 col-lg-6 col-xl-6">               
                <div id="dvmenu-ve" class="container-fluid" style="margin-top: 15px;">
                    <div class="row">
                        <div class="col-md-12">
                            <ul class="list-group list-group-flush">
                                <li class="list-group-item list-group-item-action rounded item-lst-menu-ve" @click.prevent="mtdrotinaclientes()">
                                    <div class="row">
                                        <div class="col-2 col-md-2 text-center">
                                            <i class="fa fa-users icones-menu-ve"></i>                                            
                                        </div>
                                        <div class="col-10 col-md-10">
                                            <span class="tit-item-menu-ve">Clientes</span><br>
                                            <span class="sub-tit-item-menu-ve">Listagem dos clientes e suas informações</span>
                                        </div>
                                    </div>
                                </li>                        
                                <li class="list-group-item list-group-item-action rounded item-lst-menu-ve" @click.prevent="mtdrotinaprodutos()">
                                    <div class="row">
                                        <div class="col-2 col-md-2 text-center">
                                            <i class="fa fa-cubes icones-menu-ve"></i>                                            
                                        </div>
                                        <div class="col-10 col-md-10">
                                            <span class="tit-item-menu-ve">Produtos</span><br>
                                            <span class="sub-tit-item-menu-ve">Listagem dos produtos</span>
                                        </div>
                                    </div>
                                </li>                                                        
                                <li class="list-group-item list-group-item-action rounded item-lst-menu-ve" @click.prevent="mtdrotinavendas()">
                                    <div class="row">
                                        <div class="col-2 col-md-2 text-center">
                                            <i class="fa fa-line-chart icones-menu-ve"></i>                                            
                                        </div>
                                        <div class="col-10 col-md-10">
                                            <span class="tit-item-menu-ve">Pedidos</span><br>
                                            <span class="sub-tit-item-menu-ve">PAINEL DE pedidos, Gráficos e outras</span>
                                        </div>
                                    </div>
                                </li>                                                                                        
                            </ul>                                                        
                        </div>
                    </div>
                </div>
                <div id="dvclientes-ve" class="container-fluid dvhide" style="margin-top: 10px;">
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col-12 col-sm-12 col-md-12" style="padding: 0px;">
                            <div class="card" style="border-radius: 20px;">
                                <div class="card-body" style="padding: 0.25rem;">
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <button v-if="!vendaativa" type="button" class="btn btn-light btn-voltar-ve" @click.prevent="mtdgotomenuve()"><i class="fa fa-angle-left"></i></button>
                                            <button v-else type="button" class="btn btn-light btn-voltar-ve" @click.prevent="mtdvenda_ativa()"><i class="fa fa-angle-left"></i></button>
                                            <span id="sp-titulove">CLIENTES</span>
                                        </div>
                                    </div>    
                                </div>
                            </div>                                                        
                        </div>                
                    </div>                    
                    <div class="row border rounded" style="padding: 15px 0px 15px 0px;">
						<div class="col-8 col-md-4">
							<label for="cbopfiltroccve">Filtrar:</label>
							<select name="cbopfiltroccve" class="form-control form-control-sm" id="cbopfiltroccve" v-model="pfiltroccve">
                                    <option value="0">Código</option>
                                    <option value="1">Nome/Razão Social</option>
                                    <option value="2">Fantasia</option>
                                    <option value="3">Cnpj/Cpf</option>
                                    <option value="4">Insc.Estadual/Rg</option>
                                    <option value="5">Nº Cartão</option>
                                    <option value="6">Telefone(1)</option>
                                    <option value="7">Telefone(2)</option>
							</select>
						</div>
						<div class="col-8 col-md-6">
							<label for="edconteudopesqccve">Conteúdo da pesquisa:</label>
							<input id="edconteudopesqccve" type="text" class="form-control form-control-sm" v-model="pconteudoccve">
						</div>
                        <div class="col-4 col-md-2">
                            <button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdexecutapesquisaclientes()"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="col-md-12" style="margin-top: 15px; height: 330px; overflow:auto;">
                            <ul class="list-group list-group-flush">
                                <li  v-for="(cliente, indice) in lstclientesccve" :key="indice" @click.prevent="vendaativa ? mtdselecionarcliente(cliente) : mtdmenucliente(cliente)" class="list-group-item list-group-item-action rounded item-lst-menu-ve">
                                    <div class="row">
                                        <!-- <div class="col-2 col-md-2 text-center">
                                            <i class="fa fa-users icones-menu-ve"></i>                                            
                                        </div> -->
                                        <div class="col-12 col-md-12">
                                            <span class="tit-item-menu-ve">{{ cliente.nome }}</span><br>                                            
                                        </div>
                                        <div class="col-6 col-md-8">                                  
                                            <span class="sub-tit-item-menu-ve">{{cliente.fantasia}}</span>      
                                        </div>
                                        <div class="col-6 col-md-4 text-right">                                  
                                            <span class="sub-tit-item-menu-ve">{{mtdformatadocumento(cliente.cnpjcpf)}}</span>      
                                        </div>                                        
                                    </div>
                                </li>
                            </ul>                                
                        </div>
                        <div class="col-md-12" style="margin-top: 10px;">
                            <div class="row">
                                <div class="col-md-12">
                                    <v-pagination
                                            v-model="pagina_atualccve"
                                            :page-count="pqtd_paginasccve"
                                            :classes="bootstrapPaginationClasses">
                                    </v-pagination>
                                </div>  
                            </div>                              
                        </div>                                                                        
                    </div>
                </div>
                <div id="dvprodutos-ve" class="container-fluid dvhide" style="margin-top: 10px;">
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col-12 col-sm-12 col-md-12" style="padding: 0px;">
                            <div class="card" style="border-radius: 20px;">
                                <div class="card-body" style="padding: 0.25rem;">
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <button v-if="!vendaativa" type="button" class="btn btn-light btn-voltar-ve" @click.prevent="mtdgotomenuve()"><i class="fa fa-angle-left"></i></button>
                                            <button v-else type="button" class="btn btn-light btn-voltar-ve" @click.prevent="mtdvenda_ativa()"><i class="fa fa-angle-left"></i></button>
                                            <span id="sp-titulove">PRODUTOS</span>
                                        </div>
                                    </div>    
                                </div>
                            </div>                                                        
                        </div>                
                    </div>                    
                    <div class="row border rounded" style="padding: 15px 0px 15px 0px;">
						<div class="col-5 col-md-4">
							<label for="cbopfiltrocp">Filtrar:</label>
							<select name="cbopfiltrocp" class="form-control form-control-sm" id="cbopfiltrocp" v-model="pfiltrocpve">
								<option value="0">Código</option>
								<option value="1">Descrição</option>
								<option value="2">Referência</option>
							</select>
						</div>
						<div class="col-7 col-md-8">
							<label for="edconteudopesqcp">Conteúdo da pesquisa:</label>
							<input id="edconteudopesqcp" type="text" class="form-control form-control-sm" v-model="pconteudocpve">
						</div>
                        <div class="col-12">
                            <span class="lblselect2">Marca:</span>
                            <select id="cbmarcapesq" v-model="pidmarcave"
                                    data-placeholder="Selecione uma marca"
                                    data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
						<div class="col-8 col-md-8">
							<label for="edespecificacaopesqcp">Especificações:</label>
							<input id="edespecificacaopesqcp" type="text" class="form-control form-control-sm" v-model="pespecificacaocpve">
						</div>
                        <div class="col-4 col-md-4">
                            <button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdexecutapesquisaprodutos()"><i class="fa fa-search"></i></button>
                        </div>
                        <div class="col-md-12" style="margin-top: 15px; height: 330px; overflow:auto;">
                            <ul class="list-group list-group-flush">
                                <li  v-for="(produto, indice) in lstprodutoscpve" :key="indice" class="list-group-item list-group-item-action rounded item-lst-menu-ve" style="padding: 5px">
                                    <div class="row">
                                        <div class="col-2 col-md-2 text-center">
                                            <button type="button" class="btn btn-primary btn-sm btn-op-item-ve" title="Visualizar fotos" @click.prevent="mtdvisualizarimagens(produto)"><i class="fa fa-picture-o"></i></button>&nbsp; 
                                            <button type="button" class="btn btn-secondary btn-sm btn-op-item-ve" title="Visualizar estoque" @click.prevent="mtdvisualizarestoque(produto)" style="margin-top: 5px;"><i class="fa fa-cube"></i></button>
                                        </div>
                                        <div class="col-10 col-md-10" @click.prevent="mtdrotinaitem(produto)" style="padding-left: 0px;">
                                            <div class="row">
                                                <div class="col-12">
                                                    <span class="tit-item-menu-ve">{{ produto.descricao }}</span>
                                                </div>
                                                <div class="col-5">
                                                    <span class="sub-tit-item-menu-ve">{{produto.descmarca}}</span>
                                                </div>
                                                <div class="col-7">
                                                    <span class="sub-tit-item-menu-ve" title="Referência">{{produto.referencia}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>                                
                        </div>
                        <div class="col-md-12" style="margin-top: 10px;">
                            <div class="row">
                                <div class="col-md-12">
                                    <v-pagination
                                            v-model="pagina_atualcpve"
                                            :page-count="pqtd_paginascpve"
                                            :classes="bootstrapPaginationClasses">
                                    </v-pagination>
                                </div>  
                            </div>                              
                        </div>                        
                    </div>                    
                </div>                
                <div id="dvvendas-ve" class="container-fluid dvhide" style="margin-top: 10px;">
                    <div class="row" style="margin-bottom: 10px;">
                        <div class="col-12 col-sm-12 col-md-12" style="padding: 0px;">
                            <div class="card" style="border-radius: 20px;">
                                <div class="card-body" style="padding: 0.25rem;">
                                    <div class="row">
                                        <div class="col-md-12 text-center">
                                            <button v-if="!vendaativa" type="button" class="btn btn-light btn-voltar-ve" @click.prevent="mtdgotomenuve()"><i class="fa fa-angle-left"></i></button>                                                                        
                                            <button v-else type="button" class="btn btn-light btn-voltar-ve" @click.prevent="mtdvoltarlistapedidos()"><i class="fa fa-angle-left"></i></button>                                                                                                                                                                
                                            <span v-if="parseInt(opcrud) === 1" id="sp-titulove">PEDIDOS</span>
                                            <span v-else id="sp-titulove">ALTERAÇÃO DE PEDIDO ({{mtdformatarzeros(vid, 8)}})</span>
                                        </div>
                                    </div>    
                                </div>
                            </div>                                                        
                        </div>                
                    </div>                    
                    <div id="dv-listagempedidos" class="row border rounded" style="padding: 15px 0px 15px 0px;">                    
                        <div class="col-12">
                            <span class="lblselect2">Filial:</span>
                            <select id="cbfilialpesqve" data-placeholder="Selecione uma filial" v-model="pidfilialve" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-4">
                            <label for="edidpedidopesq">Nr. Pedido:</label>
                            <input id="edidpedidopesq" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pidpedido">
                        </div>                        
                        <div class="col-8">
                            <span class="lblselect2">Vendedor:</span>
                            <select id="cbvendedorpesq" data-placeholder="Selecione um vendedor" v-model="pidvendedor" data-allow-clear="true" v-bind:disabled="!pumanipulavendedor" style="width:100%;">
                            </select>
                        </div>                        
                        <div class="col-12 col-sm-12 col-md-8 col-lg-8">
                            <span class="lblselect2">Parceiro cliente:</span>
                            <select id="cbclientepesq" data-placeholder="Selecione um cliente" v-model="pidclienteve" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                        
                        <div class="col-7 col-sm-7 col-md-4 col-lg-4">
                            <label for="cbsituacaopesqve">Situação:</label>
                            <select name="cbsituacaopesqve" class="form-control form-control-sm" id="cbsituacaopesqve" v-model="psituacaove">
                                <option value="0">Abertos</option>
                                <option value="1">Faturados</option>
                                <option value="2">Cancelados</option>
                                <option value="3">Todos</option>
                            </select>
                        </div>                        
                        <div class="col-5 col-sm-5 col-md-2 col-lg-2">
                            <label for="cbfiltroperiodove">Período:</label>
                            <select class="form-control form-control-sm" id="cbfiltroperiodove" v-model="pfiltroperiodove" v-bind="selecionaperiodove">
                                <option value="0">Não</option>
                                <option value="1">Sim</option>
                            </select>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 col-lg-4">
                            <label for="eddtinive">De:</label>
                            <div class="input-group">
                                <date-picker id="eddtinive" v-model="pdtinive" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodove"></date-picker>
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                </div>								
                            </div>
                        </div>
                        <div class="col-6 col-sm-6 col-md-4 col-lg-4">
                            <label for="eddtfimve">até:</label>
                            <div class="input-group">
                                <date-picker id="eddtfimve" v-model="pdtfimve" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodove"></date-picker>
                                <div class="input-group-append">
                                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                </div>																			
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                            <button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdexecutapesquisaped()"><i class="fa fa-search"></i></button>
                        </div> 
                        <template v-if="lstpedidosve.length === 0">                        
                            <div class="col-md-12" style="margin-top: 15px; padding-left: 30px; padding-right: 30px;">
                                <div class="row border rounded" style="height: 240px; overflow:auto;">
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-md-12" style="margin-top: 15px; height: 240px; overflow:auto;">
                                <ul class="list-group list-group-flush">
                                    <li  v-for="(pedido, indice) in lstpedidosve" :key="indice" class="list-group-item list-group-item-action rounded item-lst-menu-ve" @click.prevent="mtdmostrarmenu(pedido)">
                                        <div class="row">
                                            <div class="col-5">
                                                <span class="tit-item-menu-ve" style="padding-right: 5px;">{{ mtdformatarzeros(pedido.id, 8) }}</span>
                                                <i v-if="parseInt(pedido.liberarpdv) === 1" class="fa fa-unlock" style="color: #5A956A;" title="Liberado para o PDV"></i>
                                                <i v-else class="fa fa-lock" style="color: #EEA435;" title="Bloqueado para o PDV"></i>                                                
                                            </div>
                                            <div class="col-3 text-right">
                                                <span class="tit-item-menu-ve">{{ pedido.dtemissao }}</span>
                                            </div>                                            
                                            <div class="col-4 text-right">
                                                <template v-if="parseInt(pedido.stpedido) === 0">
                                                    <span class="badge badge-primary badge-pill">ABERTO</span>
                                                </template>
                                                <template v-else-if="parseInt(pedido.stpedido) === 1">
                                                    <span class="badge badge-secondary badge-pill" style="background-color: #5A956A;">FATURADO</span>
                                                </template>
                                                <template v-else>
                                                    <span class="badge badge-danger badge-pill">CANCELADO</span>
                                                </template>                                                
                                            </div>
                                            <div class="col-9">
                                                <span class="tit-item-menu-ve">{{ pedido.nomecliente }}</span>
                                            </div>
                                            <div class="col-3 text-right">
                                                <span class="tit-item-menu-ve">{{ mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2) }}</span>
                                            </div>                                            
                                        </div>
                                    </li>
                                </ul>                             
                            </div>
                        </template>
                        <div class="col-12" style="margin-top: 10px;">
                            <ul class="list-group">
                                <a class="list-group-item lstdettot">Total aberto <span class="badge badge-info" style="position: absolute;font-size: 12px;left: 120px;width: 40px; top: 7px;">{{ pqa }}</span>
                                    <span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(ptotalaberto, 2) }}</span></a>
                            </ul>
                        </div>
                        <div class="col-12">
                            <ul class="list-group">
                                <a class="list-group-item lstdettot">Total faturado <span class="badge badge-info" style="position: absolute;font-size: 12px;left: 120px;width: 40px; top: 7px;">{{ pqf }}</span>
                                    <span class="badge badge-primary bdg-totais" style="background-color: #5a956a;">{{ mtdformatavalordecimal(ptotalfaturado, 2) }}</span></a>
                            </ul>
                        </div>
                        <div class="col-12">
                            <ul class="list-group">
                                <a class="list-group-item lstdettot">Total cancelado <span class="badge badge-info" style="position: absolute;font-size: 12px;left: 120px;width: 40px; top: 7px;">{{ pqc }}</span>
                                    <span class="badge badge-danger bdg-totais">{{ mtdformatavalordecimal(ptotalcancelado, 2) }}</span></a>
                            </ul>
                        </div>
                        <div class="col-7">
                        </div>
                        <div class="col-5">
                            <button id="btnovopedido" type="button" @click.prevent="mtdnovavenda()"
                                class="btn btn-primary btn-sm btn-block" style="margin-top:10px;"><i class="fa fa-file"></i> Criar
                            </button>
                        </div>                        
                    </div>    
                    <div id="dv-venda-ativa" class="row border rounded" style="padding: 15px 0px 15px 0px; display: none;">
                        <div class="col-md-12">
                            <span class="lblselect2">Filial:</span>
                            <select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-md-12" style="margin-top: 10px;">
                            <button v-if="vidcliente === null" type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdrotinaclientes()"><i class="fa fa-id-card-o"></i> Selecione o cliente</button>
                            <button v-else type="button" class="btn btn-success btn-block btn-sm" @click.prevent="mtdrotinaclientes()"><i class="fa fa-pencil-square-o"></i> {{ mtdformatarzeros(vidcliente, 6) }} - {{ vnomecliente }}</button>
                        </div>
                        <div class="col-md-12" style="margin-top: 10px;">
                            <button v-if="vidplano === null" type="button" class="btn btn-secondary btn-block btn-sm" @click.prevent="mtdselecionarplano()"><i class="fa fa-pencil-square-o"></i> Selecione o plano</button>
                            <button v-else type="button" class="btn btn-secondary btn-block btn-sm" @click.prevent="mtdselecionarplano()"><i class="fa fa-pencil-square-o"></i> {{ mtdformatarzeros(vidplano, 2) }} - {{ vdescplano }}</button>
                        </div>                                                
                        <div class="col-6 col-md-6" style="margin-top: 10px; margin-bottom: 10px;">
                            <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadcionaritem()"><i class="fa fa-plus"></i> ítem</button>
                        </div>											
                        <div class="col-6 col-md-6" style="margin-top: 10px; margin-bottom: 10px;">
                            <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdaplicardesconto()"><i class="fa fa-percent"></i> Desconto <i class="fa fa-dollar"></i></button>
                        </div>

                        <div class="col-12">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" href="#dvitens">Itens</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Anotações</a>
                                </li>																								
                            </ul>
                            <div class="tab-content border-left border-right border-bottom" style="padding-top: 0px; padding-bottom: 10px;">
                                <div id="dvitens" class="container-fluid tab-pane active">
                                    <div class="row">
                                        <template v-if="lstitens.length === 0">                        
                                            <div class="col-md-12" style="padding-left: 30px; padding-right: 30px; margin-top: 10px;">
                                                <div class="row border rounded" style="height: 280px; overflow:auto;">
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col-md-12" style="margin-top: 15px; height: 280px; overflow:auto;">
                                                <ul class="list-group list-group-flush">
                                                    <li  v-for="(item, indice) in lstitens" :key="indice" class="list-group-item list-group-item-action rounded item-lst-menu-ve">
                                                        <div class="row">
                                                            <div class="col-2 col-sm-1">
                                                                <span class="tit-item-menu-ve">{{ mtdformatarzeros(item.item, 3) }}</span>
                                                            </div>
                                                            <div class="col-3 col-sm-2 text-right">
                                                                <span class="tit-item-menu-ve">{{ item.idproduto }}</span>
                                                            </div>
                                                            <div class="col-3 col-sm-3">
                                                                <span class="sub-tit-item-menu-ve">{{ item.desctabela }}</span>
                                                            </div>                                                            
                                                            <div class="col-4 col-sm-6 text-right">
                                                                <button type="button" class="btn btn-primary btn-sm btn-op-item-ve" title="Editar item" @click.prevent="mtdrotinaalteraritem(item)"><i class="fa fa-edit"></i></button>&nbsp; 
                                                                <button type="button" class="btn btn-danger btn-sm btn-op-item-ve" title="Remover item" @click.prevent="mtdexcluiritem(item.item)"><i class="fa fa-trash"></i></button>
                                                            </div>
                                                            <div class="col-12">
                                                                <span class="tit-item-menu-ve">{{ item.descproduto }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-3 col-sm-3 text-right">
                                                                <span class="tit-item-menu-ve">{{ item.qtditem }} {{ item.unditem }}</span>
                                                            </div>
                                                            <div class="col-3 col-sm-3 text-right">
                                                                <span class="tit-item-menu-ve" style="position: absolute; left: 0;">X</span> <span class="tit-item-menu-ve">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</span>
                                                            </div>
                                                            <div class="col-3 col-sm-3 text-right">
                                                                <template v-if="parseFloat(item.valordescacres) > 0">
                                                                    <template v-if="parseInt(item.tipodescacres) === 0">
                                                                        <span class="tit-item-menu-ve">- {{ mtdformatavalordecimal(parseFloat(item.valordescacres), 2) }} (%)</span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class="tit-item-menu-ve">- {{ mtdformatavalordecimal(parseFloat(item.valordescacres), 2) }} ($)</span>
                                                                    </template>	                                            
                                                                </template>
                                                            </div>
                                                            <div class="col-3 col-sm-3 text-right">
                                                                <span class="tit-item-menu-ve" style="position: absolute; left: 0;">=</span> <span class="tit-item-menu-ve">{{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}</span>
                                                            </div>                                        
                                                        </div>
                                                    </li>
                                                </ul>                             
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div id="dvobservacoes" class="container-fluid tab-pane">
                                    <div class="row">
                                        <div class="col-12" style="margin-top: 10px;">
                                            <textarea class="form-control center" rows="11" id="txtobservacoes" v-model="vobservacoes"></textarea>
                                        </div>                                        
                                    </div>
                                </div>                                
                            </div>                                                                
                        </div>
                        <div class="col-12" style="margin-top: 10px;">
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                    <span style="color: #666666; font-weight: bold;">Itens: <span style="font-weight: 600;">{{mtdformatarzeros(lstitens.length, 3)}}</span></span>
                                    <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{mtdformatavalordecimal(parseFloat(totalgeral), 2)}}</span>
                                </li>
                            </ul>                            
                        </div>
                        <div class="col-6 col-md-4">                            
                            <div class="custom-control custom-switch border rounded" style="margin-top: 10px; padding: 5px;">
                                <input type="checkbox" class="custom-control-input" id="cbentregaexterna" v-model="ventregaexterna">
                                <label class="custom-control-label" for="cbentregaexterna" id="lblentregar" style="margin-left: 40px;">Entregar</label>
                            </div>
                        </div>
                        <div class="col-6 col-md-4">                            
                            <div class="custom-control custom-switch border rounded" style="margin-top: 10px; padding: 5px;">
                                <input type="checkbox" class="custom-control-input" id="cbreservar" v-model="vreservar">
                                <label class="custom-control-label" for="cbreservar" id="lblreservar" style="margin-left: 40px;">Reservar</label>
                            </div>
                        </div>                        
                        <div class="col-12 col-md-4">
                            <button id="btgravar" type="button" @click.prevent="mtdgravar()"
                                class="btn btn-primary btn-sm btn-block" style="margin-top:10px;"><i class="fa fa-check"></i> Salvar
                            </button>
                        </div>                            
                    </div>                    
                </div>
            </div>
            <div class="col-12 col-md-2 col-lg-3 col-xl-3">                
            </div>
        </div>

		<!-- Modal para seleção do plano de pagamento -->
		<div class="modal fade" id="mdselecionarplano">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="list-group">								
								<a v-for="(plano, index) in lstplanos" href="#" v-bind:class="parseInt(plano.id) === parseInt(vidplano) ? 'active': ''" v-bind:key="index" class="list-group-item list-group-item-action font-weight-bold" @click.prevent="mtddefineplano(plano)">{{ mtdformatarzeros(plano.id, 2) }} - {{ plano.descricao }}</a>
							</div>							
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
        <!-- Modal para edição do item -->
        <div class="modal fade" id="mdedicaoitemve" tabindex="-1" role="dialog" aria-labelledby="mdedicaoitemve" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" style="font-size: 14px;"><i class="fa fa-cubes"></i> Edição de item</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="container-fluid">
                                    <div class="row">                      
                                        <div class="col-12 border rounded text-center" style="padding-top: 10px; padding-bottom: 10px; min-height: 75px;">          
                                            <span class="spn-item-edicao">{{idprodutoedicao}} - {{descricaoprodutoedicao}}</span>
                                            <button type="button" class="btn btn-secondary btn-sm btn-op-item-ve" title="Visualizar estoque" @click.prevent="mtdvisualizarestoque({id : idprodutoedicao, descricao : descricaoprodutoedicao})" style="position: absolute; right: 5px; top: 10px;"><i class="fa fa-cube"></i></button>
                                            <button v-show="observacoesprodutoedicao !== ''" type="button" 
                                                class="btn btn-info btn-sm btn-op-item-ve" title="Anotações/Detalhes" 
                                                style="position: absolute; right: 5px; top: 38px; width: 28px;" 
                                                data-toggle="popover" data-trigger="focus" v-bind:data-content="observacoesprodutoedicao">
                                                <i class="fa fa-info"></i>                                                
                                            </button>
                                        </div>
                                    </div>
                                </div>        
                            </div> 
                            <div class="col-12 col-sm-6">
                                <div class="container-fluid">
                                    <div class="row">                      
                                        <div class="col-12 border rounded" style="margin-top: 10px; padding-top: 5px; padding-bottom: 10px;">          
                                            <span class="spn-item-edicao">REF: {{referenciaprodutoedicao}}</span>
                                        </div>
                                    </div>
                                </div>        
                            </div>                                                        
                            <div class="col-12 col-sm-6">
                                <div class="container-fluid">
                                    <div class="row">                      
                                        <div class="col-12 border rounded" style="margin-top: 10px; padding-top: 5px; padding-bottom: 10px;">          
                                            <span class="spn-item-edicao">MARCA: {{descmarcaedicao}}</span>
                                        </div>
                                    </div>
                                </div>        
                            </div>                             
							<div class="col-8" style="margin-top: 10px;">
								<label for="cbtabelasproduto">Tabela:</label>
								<select class="form-control form-control-sm" id="cbtabelasproduto" v-model="idtabelaprodutoedicao" @change="mtdselecionaprecotabela()" v-bind:disabled="!pumanipulartabelasitem">
                                    <option v-for="(tabela, indice) in lsttabelasproduto" v-bind:key="indice" v-bind:value="tabela.id">{{tabela.descricao}}</option>
								</select>
							</div>
							<div class="col-4" style="margin-top: 10px;">
								<label for="edvlunitarioedicao">Valor:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vlunitarioedicao" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;" disabled></money>
							</div>                                                                                      
                            <div class="col-12 col-md-4" style="margin-top: 10px;">
                                <label for="edqtdenviar">Quantidade:</label>
								<div class="input-group" style="z-index: 1;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidade(2)"><i class="fa fa-minus" style="padding-top: 3px;"></i></a>
									</div>								
									<money type="text" class="form-control form-control-sm" id="edqtdenviar" v-model="qtditemedicao" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidade(1)"><i class="fa fa-plus" style="padding-top: 3px;"></i></a>
									</div>									
								</div>
                            </div>
							<div class="col-6 col-md-4" style="margin-top: 10px;">
								<label for="cbtipodescacresedicao">Tipo desconto:</label>
								<select class="form-control form-control-sm" id="cbtipodescacresedicao" v-model="tipodescacresedicao" v-bind:disabled="parseInt(permitedescontove) === 0">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-6 col-md-4" style="margin-top: 10px;">
								<label v-if="parseInt(tipodescacresedicao) === 0" for="edfatordesconto">Descto(%):</label>
                                <label v-else for="edfatordesconto">Descto($):</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescto" v-model="fatordescontoitemedicao" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;" v-bind:disabled="parseInt(permitedescontove) === 0"></money>
							</div>
                            <div class="col-6 col-md-8" style="margin-top: 10px;">                                
                            </div>
							<div class="col-6 col-md-4" style="margin-top: 10px;">
								<label for="edvltotalitemedicao">Total item:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotalitemedicao" v-model="vltotalitemedicao" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: 600;" disabled></money>
							</div>                                                                                                                                            
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-primary btn-sm" role="button" @click.prevent="mtdgravaritem()"><i class="fa fa-check"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</a>
                    </div>
                </div>
            </div>
        </div> 
		<!-- Modal para aplicação do desconto nos itens -->
		<div class="modal fade" id="mdaplicardesconto">
			<div class="modal-dialog modal-sm modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Aplicar desconto</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">							
							<div class="col-md-12">
								<label for="edtotalitenssemdesconto">Total dos itens SEM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenssemdesconto" v-model="totalsemdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
							<div class="col-md-12">
								<label for="cbtipodesctotal">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodesctotal" v-model="tipodesctotal" style="font-size: 18px; font-weight: bold;">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(tipodesctotal) === 0" for="edfatordescontototal">Percentual do desconto</label>
								<label v-else for="edfatordescontototal">Valor do desconto</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="fatordescontototal" v-bind="[calculadescontototalitens, money]" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;"></money>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(tipodesctotal) === 0" for="edfatordescontototal">Desconto(R$)</label>
								<label v-else for="edfatordescontototal">Desconto(%)</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="resdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;" disabled></money>
							</div>														
							<div class="col-md-12">
								<label for="edtotalitenscomdesconto">Total dos itens COM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenscomdesconto" v-model="totalcomdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaaplicacaodesconto()"><i class="fa fa-check"></i> Aplicar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
					</div>        
				</div>
			</div>
		</div>
        <!-- Menu dos pedidos -->
		<div class="modal fade" id="mdmenupedido">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(pedidomenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(pedidomenu)"><i class="fa fa-edit"></i> EDITAR</li>
                                <li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdquestionaexclusaopedido(pedidomenu)"><i class="fa fa-trash"></i> REMOVER</li>                                
								<li v-if="parseInt(pedidomenu.liberarpdv) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinapdv(pedidomenu.id)"><i class="fa fa-unlock"></i> LIBERAR PDV</li>
								<li v-else class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinapdv(pedidomenu.id)"><i class="fa fa-lock"></i> BLOQUEAR PDV</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefimpressao" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">									
											<i class="fa fa-print"></i> IMPRIMIR
										</div>
										<div id="dvdefimpressao" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirpedido(pedidomenu.id, 0)"><i class="fa fa-file-text-o"></i> Padrão</button>
														</div>
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirpedido(pedidomenu.id, 1)"><i class="fa fa-wpforms"></i> Cupom</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>										
								</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefguiaseparacao" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">									
											<i class="fa fa-print"></i> GUIA SEPARAÇÃO
										</div>
										<div id="dvdefguiaseparacao" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirguiaseparacao(pedidomenu.id, 0)"><i class="fa fa-file-text-o"></i> Padrão</button>
														</div>
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirguiaseparacao(pedidomenu.id, 1)"><i class="fa fa-wpforms"></i> Cupom</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>										
								</li>								

							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
        <!-- Menu dos clientes -->
		<div class="modal fade" id="mdmenucliente">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active"     style="font-size: 18px;">{{ mtdformatarzeros(clientemenu.id, 6) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdfinanceirocliente()" data-dismiss="modal"><i class="fa fa-money"></i> DÉBITOS</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdhistoricocompraprodutos()" data-dismiss="modal"><i class="fa fa-cubes"></i> HISTÓRICO DE COMPRA</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
        <!-- Financeiro do cliente -->
		<div class="modal fade" id="mdfinanceirocliente">
			<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel" style="font-size: 16px;"><i class="fa fa-money"></i> Débitos do cliente</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>                
				<div class="modal-body" style="padding: 5px;">
					<div class="row">
                        <div class="col-12" style="margin-bottom: -15px;">
                            <div class="alert alert-success text-center" style="padding: 5px; background-color: #4250f2; border-color: #4250f2;">
                                <strong style="font-size: 14px; color: #f3f1f1;">{{ mtdformatarzeros(clientemenu.id, 6) }} - {{ clientemenu.nome }}</strong>
                            </div>                                
                        </div>
                        <div class="col-md-12" style="margin-top: 5px; height: 280px; overflow:auto;">
                            <ul class="list-group list-group-flush">
                                <li  v-for="(titulo, indice) in lsttituloscliente" :key="indice" class="list-group-item list-group-item-action rounded item-lst-menu-ve" style="padding: 5px 10px;">
                                    <div class="row">
                                        <div class="col-4">
                                            <span class="tit-titulo-cli" title="Nr. do título">{{ titulo.codtit }}</span>
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="tit-titulo-cli" title="Data Emissão">{{ titulo.dtemitit }}</span>
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="tit-titulo-cli" title="Data Vencimento">{{ titulo.dtventit }}</span>
                                        </div>
                                        <div class="col-2 text-right">
                                            <span v-if="parseInt(titulo.atraso) > 0" class="tit-titulo-cli text-danger" style="font-weight: 700;" title="Atraso">{{ titulo.atraso }}</span>
                                            <span v-else></span>
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="tit-titulo-cli" title="Valor do título">{{ mtdformatavalordecimal(parseFloat(titulo.vlresta), 2) }}</span>
                                        </div>                                                                                                                                                                
                                    </div>
                                    <div class="row">
                                        <div class="col-4">                                            
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="tit-titulo-cli" title="Vl. Juros">{{ mtdformatavalordecimal(parseFloat(titulo.vljuros), 2) }}</span>
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="tit-titulo-cli" title="Vl. Multa">{{ mtdformatavalordecimal(parseFloat(titulo.vlmulta), 2) }}</span>
                                        </div>
                                        <div class="col-2">
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="tit-titulo-cli" style="color: #5A956A; font-weight: 900;" title="Vl. à receber">{{ mtdformatavalordecimal(parseFloat(titulo.vlapagar), 2) }}</span>
                                        </div>                                              
                                    </div>
                                </li>
                            </ul>                             
                        </div>                        
                        <div class="col-12">
                            <ul class="list-group">
                                <a class="list-group-item lstdetrec">Vencidos <span class="badge badge-danger bdgtitulos">{{ mtdformatavalordecimal(vrVencidos, 2) }}</span></a>
                                <a class="list-group-item lstdetrec">A vencer <span class="badge badge-primary bdgtitulos">{{ mtdformatavalordecimal(vrAvencer, 2) }}</span></a>
                                <a class="list-group-item lstdetrec">Juros <span class="badge badge-warning bdgtitulos">{{ mtdformatavalordecimal(vrJuros, 2) }}</span></a>
                                <a class="list-group-item lstdetrec">Multa <span class="badge badge-info bdgtitulos">{{ mtdformatavalordecimal(vrMulta, 2) }}</span></a>
                                <a class="list-group-item lstdetrec">Total consolidado <span class="badge badge-info" style="font-size: 12px;">{{ lsttituloscliente.length }}</span>
                                    <span class="badge badge-success bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(vrTotal, 2) }}</span></a>
                            </ul>
                        </div>                                                
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>	
				</div>				        
			</div>
			</div>
		</div>
        <!-- Histórico de compras de produtos do cliente -->
		<div class="modal fade" id="mdprodutoscliente">
			<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel" style="font-size: 16px;"><i class="fa fa-money"></i> Histórico de compra de produtos</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>                
				<div class="modal-body" style="padding: 5px;">
					<div class="row">
                        <div class="col-12" style="margin-bottom: -15px;">
                            <div class="alert alert-success text-center" style="padding: 5px; background-color: #4250f2; border-color: #4250f2;">
                                <strong style="font-size: 14px; color: #f3f1f1;">{{ mtdformatarzeros(clientemenu.id, 6) }} - {{ clientemenu.nome }}</strong>
                            </div>                                
                        </div>
                        <div class="col-md-12" style="margin-top: 5px; height: 300px; overflow:auto;">
                            <ul class="list-group list-group-flush">
                                <li  v-for="(produto, indice) in lstprodutoscliente" :key="indice" class="list-group-item list-group-item-action rounded item-lst-menu-ve" style="padding: 5px 10px;">
                                    <div class="row">
                                        <div class="col-4">
                                            <span class="tit-titulo-cli" title="Código">ID: {{ produto.idproduto }}</span>
                                        </div>
                                        <div class="col-8">
                                            <span class="tit-titulo-cli" title="Referência">REF: {{ produto.referencia }}</span>
                                        </div>                                                                                                                                                  
                                    </div>
                                    <div class="row">
                                        <div class="col-12">                                            
                                            <span class="tit-titulo-cli">{{ produto.descricao }}</span>
                                        </div>
                                        <div class="col-2 text-right">
                                            <span class="tit-titulo-cli" title="Quantidade">{{ produto.qtditem }}</span>
                                        </div>
                                        <div class="col-4">
                                            <span class="tit-titulo-cli" title="Tabela">{{ produto.desctabela }}</span>
                                        </div>
                                        <div class="col-3 text-right">
                                            <span class="tit-titulo-cli" style="color: #5A956A; font-weight: 900;" title="Total do item">{{ mtdformatavalordecimal(parseFloat(produto.vltotal), 2) }}</span>
                                        </div>                                              
                                        <div class="col-3 text-right">
                                            <span class="tit-titulo-cli" title="Data">{{ produto.dtemissao }}</span>
                                        </div>                                                                                      
                                    </div>
                                </li>
                            </ul>                             
                        </div>
                        <div class="col-12" style="margin-top: 5px;">
                            <ul class="list-group">
                                <a class="list-group-item lstdetrec">Total <span class="badge badge-danger bdgtitulos" style="background: #5A956A;">{{ mtdformatavalordecimal(totalfaturadocliente, 2) }}</span></a>
                            </ul>
                        </div>                                                                                  
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>	
				</div>				        
			</div>
			</div>
		</div>                
    </div>
</template>
<script>
import vPagination from 'vue-plain-pagination'
import util from '../utilitarios/util.js'
import VisualizadorEstoque from '../components/cmpvisualizadorestoque'
export default {
    name: "vendaexterna",
    components:{
        vPagination,
        'visualizadorestoque'   : VisualizadorEstoque
    },    
    data: function() {
    return {  
        utodasfiliais: this.$store.state.usuario.todasfiliais,   
        //clientes
        pfiltroccve             : 1,
        pconteudoccve           : '',
        pqtdregistrosccve       : 10,
        pagina_atualccve        : 1,        
        pqtd_paginasccve        : 1,
        pqtd_total_registrosccve: 0,
        lstclientesccve         : [],

        //PAINEL DE pedidos
        lstpedidosve   		    : [],
        pidfilialve	 		    : null,
        pidpedido               : '',
        pidclienteve            : null,
        pidvendedor             : null,
        pfiltroperiodove        : 1,
        pdtinive       		    : util.DataAtual(true),
        pdtfimve       		    : util.DataAtual(true),				
        psituacaove	 		    : 0,
        ptotalaberto		    : 0,
        ptotalfaturado		    : 0,
        ptotalcusto			    : 0,
        ptotalcancelado		    : 0,
        pqa					    : 0,
        pqf					    : 0,
        pqc					    : 0,        

        //produtos
        pfiltrocpve             : 1,
        pidmarcave              : null,
        pconteudocpve           : '',
        pespecificacaocpve      : '',
        idtabelave              : 1,
        pqtdregistroscpve       : 10,
        pagina_atualcpve        : 1,        
        pqtd_paginascpve        : 1,
        pqtd_total_registroscpve: 0,
        lstprodutoscpve         : [],

        
        //variaveis dos titulos do cliente
        lsttituloscliente       : [],
        vrVencidos              : 0,
        vrAvencer               : 0,
        vrJuros                 : 0,
        vrMulta                 : 0,
        vrTotal                 : 0,

        //variáveis histórico de compras
        lstprodutoscliente      : [],
        totalfaturadocliente    : 0,

        //edicao do item
        vltotal_old_edicao		: 0,//somente para a alteração
        itemalteracao			: 0,
        opitem                  : 1,
        item                    : 0,
        qtditemedicao           : 1,
        fracionadoedicao        : 0,
        idprodutoedicao         : '',
        descricaoprodutoedicao  : '',
        referenciaprodutoedicao : '',
        descmarcaedicao         : '',
        undprodutoedicao		: '',
        observacoesprodutoedicao: '',
        idtabelaprodutoedicao   : null,
        vlunitarioedicao        : 0,
        vltotalitemedicao       : 0,
        permitedescontove       : 0,
        tipodescacresedicao     : 0,
        fatordescontoitemedicao : 0,
        lsttabelasproduto       : [],
        sringaleatoria          : '',

        //totalizadores
        totalprodutos		: 0,
        totalgeral			: 0,        

        pedidomenu					: [], //para geração do menu do pedido no modal
        clientemenu					: [], //para geração do menu do cliente no modal

        //variáveis aplicação do desconto no total dos itens
        totalsemdesconto	: 0,
        totalcomdesconto    : 0,
        tipodesctotal		: 0,	
        fatordescontototal	: 0,
        resdesconto		    : 0,

        pagina_atualped         : 1,
        pqtd_total_registrosped : 0,
        pqtd_paginasped         : 1,
        pqtdregistrosped        : '9999999',

        clonar				    : false,


        //variaveis de permissao do usuario
        puvenderitemsemsaldo    : false,
        pumanipulartabelasitem  : false,
        pumanipulavendedor      : false,

        opcrud       : 1,
        vendaativa   : false,
        vid          : '',
        vidfilial    : null,
        vidcliente   : null,
        vidvendedor  : null,
        vnomecliente : '',
        vdtemissao   : util.DataAtual(),
        vreservar	 : true,
        vidplano     : null,
        vdescplano   : '',
        vtipoplano   : 0,
        vidtabela    : null,
        ventregaexterna	: false,
        vobservacoes : '',
        lstplanos  	 : [],         
        lstitens     : [],
        options: {
            format           : 'DD/MM/YYYY',
            useCurrent       : false,
            locale           : 'pt-BR'
        },
        money				: {
            decimal         : ',',
            thousands       : '.',
            prefix          : '',//aqui colocar o cifrão se for necessário
            precision       : 2,
            masked          : false
        },
        bootstrapPaginationClasses: {
            ul: 'pagination pagination-sm',
            li: 'page-item',
            liActive: 'active',
            liDisable: 'disabled',
            button: 'page-link'
        },
        //id do produto para visualização
        idprodutoestoque    : 0,
        descproestoque      : '', 
        
        //produto para visualização das imagens
        produtoviewimg      : [],
        images              : [],        
    };
    },
    methods:{
        mtdformatarzeros(str, length){
            return util.formatarzeros(str, length);
        },
        mtdformatadatagravar(dtformatar){
            let strret = dtformatar.replace(/\D/g, "");
            return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
        },        
        mtdformatafone(fone){
            return util.formatarfone(fone);
        },
        mtdformatadocumento(doc){
            return util.formatacpfcnpj(doc);
        },
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },	
        mtdfiltropesquisaped(){
            let rfiltro = ' and p.origem=4';

            if (this.pidfilialve !== null){
                rfiltro = rfiltro + ' and p.idfilial='+this.pidfilialve;
            }

            if (this.pidpedido !== ''){
                rfiltro = rfiltro + ' and p.id='+this.pidpedido;
            }

            if (this.pidvendedor !== null){
                rfiltro = rfiltro + ' and p.idvendedor='+this.pidvendedor;
            }

            if (this.pidclienteve !== null){
                rfiltro = rfiltro + ' and p.idcliente='+this.pidclienteve;
            }

            if (parseInt(this.psituacaove) < 3){
                rfiltro = rfiltro + ' and p.stpedido='+this.psituacaove;
            }	

            if(parseInt(this.pfiltroperiodove) === 1){
                rfiltro = rfiltro + ' and p.dtemissao between "' + util.InverterData(this.pdtinive) + '" and "' + util.InverterData(this.pdtfimve) + '"';
            }				

            return rfiltro;
        },
        mtdexecutapesquisaped(){
            let vself           = this;
            if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
                vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
                return;
            }				
            let filtro          = vself.mtdfiltropesquisaped();
            this.pagina_atual   = 1;
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor  : 'qtdregistros'},
                {parametro: 'filtro',       valor  : filtro}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                vself.pqtd_total_registrosped   = parseInt(response.data.qtdregistros);
                let qtdpg                       = Math.ceil(vself.pqtd_total_registrosped / vself.pqtdregistrosped);
                vself.pqtd_paginasped           = qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregapedidos(1);
            }).catch(function (response) {
                alert('Erro ao consultar registros');
            });				
        },
        mtdcarregapedidos(ipagina){
            var vself       = this;
            let loader      = this.$loading.show();
            let filtro      = vself.mtdfiltropesquisaped();
            let parametros  = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'listagem'},
                {parametro: 'filtro',       valor : filtro},
                {parametro: 'limit',        valor : vself.pqtdregistrosped},
                {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistrosped)}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                vself.lstpedidosve = response.data.pedidos;
                //totalizadores
                vself.ptotalaberto		= response.data.totalaberto;
                vself.ptotalfaturado	= response.data.totalfaturado;
                vself.ptotalcusto		= response.data.totalcusto;
                vself.ptotalcancelado	= response.data.totalcancelado;
                vself.pqa				= response.data.qa;
                vself.pqf				= response.data.qf;
                vself.pqc				= response.data.qc;
                loader.hide();											
            }).catch(function (response) {
                vself.lstpedidosve = [];
                vself.ptotalaberto		= 0;
                vself.ptotalfaturado	= 0;
                vself.ptotalcusto		= 0;
                vself.ptotalcancelado	= 0;
                vself.pqa				= 0;
                vself.pqf				= 0;
                vself.pqc				= 0;                    
                loader.hide();
            });
        },            
        mtdfiltroclientes(){
            let rfiltrocc = '';							

            switch (parseInt(this.pfiltroccve)) {
                case 0:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and c.id='+this.pconteudoccve;
                    break;
                case 1:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and upper(c.nome) like upper("'+this.pconteudoccve+'%")';
                    break;
                case 2:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and upper(c.fantasia) like upper("'+this.pconteudoccve+'%")';
                    break;  
                case 3:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and upper(c.cnpjcpf) like upper("'+this.pconteudoccve+'%")';
                    break; 
                case 4:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and upper(c.rginsc) like upper("'+this.pconteudoccve+'%")';
                    break;     
                case 5:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and upper(c.nrcartao) like upper("'+this.pconteudoccve+'%")';
                    break;  
                case 6:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and upper(c.fone1) like upper("'+this.pconteudoccve+'%")';
                    break; 
                case 7:
                    rfiltrocc = this.pconteudoccve === '' ? '' : ' and upper(c.fone2) like upper("'+this.pconteudoccve+'%")';
                    break;                                                                                                                                            
            }               

            rfiltrocc = rfiltrocc + ' and c.ativo=0';				
            
            return rfiltrocc;
        },
        mtdexecutapesquisaclientes(){
            var vself               = this;
            let filtro              = vself.mtdfiltroclientes();
            this.pagina_atualccve   = 1;
            let parametros          = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor  : 'qtdregistros'},
                {parametro: 'filtro',       valor  : filtro},
                {parametro: 'idusuariove',  valor : vself.$store.state.usuario.id}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
            retorno.then(function (response) {
                vself.pqtd_total_registrosccve 	= parseInt(response.data.qtdregistros);
                let qtdpg                  		= Math.ceil(vself.pqtd_total_registrosccve / vself.pqtdregistrosccve);
                vself.pqtd_paginasccve       		= qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaclientes(1);
            }).catch(function (response) {
                this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
            });
        },
        mtdcarregaclientes(ipagina){
            var vself       = this;
            let loader      = this.$loading.show();
            let filtro      = vself.mtdfiltroclientes();
            let parametros  = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgclientes+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'listagem'},
                {parametro: 'filtro',           valor : filtro},                
                {parametro: 'idusuariove',      valor : vself.$store.state.usuario.id},
                {parametro: 'limit',            valor : vself.pqtdregistrosccve},
                {parametro: 'offset',           valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistrosccve)},
            ];
            let retorno             = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
            retorno.then(function (response) {
                vself.lstclientesccve = response.data;
                loader.hide();
            }).catch(function (response) {
                vself.lstclientesccve = [];
                loader.hide();
            });
        },
        mtdselecionarcliente(cliente){            
            if (this.vendaativa){
                this.vidcliente   = cliente.id;
                this.vnomecliente = cliente.nome;
                //this.mtdrotinavendas();
                this.mtdlocalizarplanos();
                this.mtdvenda_ativa();                
            }
        },
        mtdlocalizarplanos(){
            let vself = this;
            if (vself.vidfilial !== null && vself.vidcliente !== ''){	
                vself.vidplano  = null;
                vself.vtipoplano= 0;				
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',           valor : 'planospedido'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',     valor : vself.vidfilial},
                    {parametro: 'idcliente',    valor : vself.vidcliente}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstplanos  = response.data;
                    if (vself.lstplanos.length > 0){
                        vself.mtddefineplano(vself.lstplanos[0]);
                    }else{
                        vself.vidplano   = null;
                        vself.vdescplano = '';
                        vself.vidtabela  = null;
                        vself.vtipoplano = 0;                        
                    }
                }).catch(function (response) {
                    vself.lstplanos  = [];
                    loader.hide();
                });				
            }else{
                vself.vidplano   = null;
                vself.vtipoplano = 0;
                vself.lstplanos  = [];					
            }
        },        
        mtdfiltroprodutos(){
            let rfiltrocp = '';							

            switch (parseInt(this.pfiltrocpve)) {
                case 0:
                    rfiltrocp = this.pconteudocpve === '' ? '' : ' and p.id='+this.pconteudocpve;
                break;
                case 1:
                    rfiltrocp = this.pconteudocpve === '' ? '' : ' and upper(p.descricao) like upper("'+this.pconteudocpve+'%")';
                break;
                case 2:
                    rfiltrocp = this.pconteudocpve === '' ? '' : ' and upper(p.referencia) like upper("'+this.pconteudocpve+'%")';
                break;
            }                            
            
            if (this.pidmarcave !== null){
                rfiltrocp = rfiltrocp + ' and p.idmarca='+this.pidmarcave;
            }

            if (this.pespecificacaocpve !== ''){
                rfiltrocp = rfiltrocp + ' and upper(p.especificacao) like upper("'+this.pespecificacaocpve+'%")';
            }

            rfiltrocp = rfiltrocp + ' and p.stpro=1 and p.tipo in (0, 2)';				

            return rfiltrocp;
        },
        mtdexecutapesquisaprodutos(){
            var vself               = this;
            let filtro              = vself.mtdfiltroprodutos();
            this.pagina_atualcpve   = 1;
            let parametros          = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor  : 'qtdregistros'},
                {parametro: 'filtro',       valor  : filtro}                    
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                vself.pqtd_total_registroscpve 	= parseInt(response.data.qtdregistros);
                let qtdpg                  		= Math.ceil(vself.pqtd_total_registroscpve / vself.pqtdregistroscpve);
                vself.pqtd_paginascpve   		= qtdpg > 0 ? qtdpg : 1;
                vself.mtdcarregaprodutos(1);
            }).catch(function (response) {
                this.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
            });
        },
        mtdcarregaprodutos(ipagina){
            var vself       = this;
            let loader      = this.$loading.show();
            let filtro      = vself.mtdfiltroprodutos();
            let parametros  = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'listagem'},
                {parametro: 'filtro',           valor : filtro},
                {parametro: 'idtabela',         valor : vself.idtabelave},
                {parametro: 'idestoque',        valor : vself.$store.state.filialpadrao.idestoque},
                {parametro: 'limit',            valor : vself.pqtdregistroscpve},
                {parametro: 'offset',           valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistroscpve)},
                {parametro: 'reserva',          valor : 1},
            ];
            let retorno             = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                vself.lstprodutoscpve = response.data;
                loader.hide();
            }).catch(function (response) {
                vself.lstprodutoscpve = [];
                loader.hide();
            });
        },                
        mtdiniciais(){
            let vself = this;

			let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
			let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';
            $('.nav-tabs a[href="#dvitens"]').tab('show');
            $("#cbfilial").select2({
                id: function (e) {return e.codfil},
                ajax: {						
                    url: vself.$store.state.configpaths.pathselect2sql,						
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q		: params.term,
                            idclientesac : vself.$store.state.filialpadrao.idcliente,
                            sqlini	: sqliniusuario,
                            sqlfim	: sqlfimusuario,
                            cpid	: 'codfil',
                            cpdesc	: 'fantasia'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.vidfilial = $("#cbfilial").val();
            });
            $("#cbfilialpesqve").select2({
                id: function (e) {return e.codfil},
                ajax: {						
                    url: vself.$store.state.configpaths.pathselect2sql,						
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q		: params.term,
                            idclientesac : vself.$store.state.filialpadrao.idcliente,
                            sqlini	: sqliniusuario,
                            sqlfim	: sqlfimusuario,
                            cpid	: 'codfil',
                            cpdesc	: 'fantasia'
                        };
                    },
                    processResults: function (data) {
                        return {
                            results: data
                        };
                    },
                    cache: true
                },
                minimumInputLength: 0,
                theme: 'bootstrap',
                language: "pt-BR",
                templateResult: util.formatResult,
                templateSelection: util.formatSelection
            }).change(function () {
                vself.pidfilialve = $("#cbfilialpesqve").val();
            });        
        
            var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.$store.state.filialpadrao.codfil, true, true);
            $('#cbfilialpesqve').append(deffilial).trigger('change');                        
        },
        mtdgotomenuve(){
            $('#dvclientes-ve').hide();
            $('#dvprodutos-ve').hide();
            $('#dvvendas-ve').hide();
            $('#dvmenu-ve').hide();
            $('#dvmenu-ve').fadeIn(700); 
        },
        mtdrotinaclientes(){
            if (!util.opcaousuario('020Z.030Z.010Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {            
                $('#dvmenu-ve').hide(); 
                $('#dvvendas-ve').hide();       
                $('#dvclientes-ve').fadeIn(700);                      
                setTimeout(() => {
                    $('#edconteudopesqccve').focus();
                }, 200);
                this.mtdexecutapesquisaclientes();
            }   
        },
        mtdselecionarplano(){
            let vself = this;
            if (vself.vidfilial === null){
                vself.$toastr.w('Filial deve ser informada!', 'Informação!');
                $('#cbfilial').focus();
                return;
            }				
            if (vself.vidcliente === ''){
                vself.$toastr.w('Cliente deve ser informado!', 'Informação!');
                $('#edcliente').focus();
                return;
            }
            $('#mdselecionarplano').modal('show');
        },
        mtddefineplano(plano){
            this.vidplano 	= plano.id;
            this.vtipoplano = plano.tipo;
            this.vdescplano	= plano.descricao;
            this.vidtabela	= plano.idtabela;
            $('#mdselecionarplano').modal('hide');
        },                
        mtdrotinaprodutos(){
            if (!util.opcaousuario('020Z.030Z.050Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {            
                $('#dvmenu-ve').hide();
                $('#dvvendas-ve').hide();
                $('#dvclientes-ve').hide();      
                $('#dvprodutos-ve').fadeIn(700);                      
                setTimeout(() => {
                    $('#cbopfiltrocp').focus();
                }, 200);
                this.mtdexecutapesquisaprodutos();
            }
        },
        mtdrotinavendas(){  
            if (!util.opcaousuario('020Z.030Z.060Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {
                this.mtdiniciais();            
                $('#dv-venda-ativa').hide();            
                $('#dv-listagempedidos').show();                                                                          
                $('#dvclientes-ve').hide();
                $('#dvmenu-ve').hide();        
                $('#dvvendas-ve').fadeIn(700);                                  
            }
        },
        mtdvoltarlistapedidos(){
            let vself = this;
            if (vself.lstitens.length > 0){
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Existe uma venda iniciada. Confirma saída?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.vendaativa = false;  
                                vself.opcrud     = 1;          
                                $('#dv-venda-ativa').hide();            
                                $('#dvclientes-ve').hide();
                                $('#dvmenu-ve').hide(); 
                                $('#dvprodutos-ve').hide();       
                                $('#dv-listagempedidos').fadeIn(700);                                                
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return;
                            }
                        }
                    }
                });                
            }else{
                vself.vendaativa = false;
                vself.opcrud     = 1;
                $('#dv-venda-ativa').hide();            
                $('#dvclientes-ve').hide();
                $('#dvmenu-ve').hide(); 
                $('#dvprodutos-ve').hide();       
                $('#dv-listagempedidos').fadeIn(700);                                                
            }
        },        
        mtdnovavenda(){
            if (!util.opcaousuario('020Z.030Z.070Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {
                this.vendaativa   = true;
                this.opcrud       = 1;      
                this.vidfilial    = null;
                this.vidcliente   = null;
                this.vidvendedor  = this.$store.state.usuario.idvendedor;
                this.vnomecliente = '';
                this.vdtemissao   = util.DataAtual();
                this.vreservar    = true;
                this.vidplano     = null;
                this.vdescplano   = '';
                this.vtipoplano   = 0;
                this.vidtabela    = null;
                this.ventregaexterna = false;
                this.vobservacoes    = '';
                this.totalgeral      = 0;
                this.totalprodutos   = 0;
                this.totalservicos  = 0;                    
                this.lstplanos       = [];         
                this.lstitens        = [];  
                this.sringaleatoria = util.GerarStringAleatoria()        

                this.mtdiniciais();
                this.vidfilial          = this.$store.state.filialpadrao.codfil;                          
                var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.vidfilial, true, true);
                $('#cbfilial').append(deffilial).trigger('change');	            
                $('#dv-listagempedidos').hide();            
                $('#dv-venda-ativa').fadeIn(700);
            }    
        },
        mtdvenda_ativa(){                    
            $('#dvclientes-ve').hide();
            $('#dvprodutos-ve').hide();
            $('#dvmenu-ve').hide();        
            $('#dvvendas-ve').fadeIn(700);                                  
        },        
        mtdlimpaedicaoitem(){
            this.qtditemedicao           = 1;
            this.fracionadoedicao        = 0,
            this.idprodutoedicao         = '';
            this.descricaoprodutoedicao  = '';
            this.referenciaprodutoedicao = '';
            this.descmarcaedicao         = '';
            this.undprodutoedicao        = '';
            this.observacoesprodutoedicao= '';
            this.idtabelaprodutoedicao   = this.vidtabela;
            this.vlunitarioedicao        = 0;
            this.vltotalitemedicao       = 0;
            this.tipodescacresedicao     = 0;
            this.fatordescontoitemedicao = 0;
            this.lsttabelasproduto       = [];      
        },        
        mtdrotinaitem(produto){
            if (this.vendaativa){
                this.opitem                  = 1;
                this.qtditemedicao           = 1;
                this.idprodutoedicao         = produto.id;
                this.descricaoprodutoedicao  = produto.descricao;
                this.referenciaprodutoedicao = produto.referencia;
                this.descmarcaedicao         = produto.descmarca;
                this.undprodutoedicao        = produto.und;
                this.observacoesprodutoedicao= produto.observacoes;
                this.fracionadoedicao        = produto.fracionado;            
                this.vlunitarioedicao        = 0;
                this.vltotalitemedicao       = 0;
                this.tipodescacresedicao     = 0;
                this.fatordescontoitemedicao = 0;  
                this.mtdtabelasprodutos(this.idprodutoedicao);           

                $('#mdedicaoitemve').modal('show');                                   
            }
        },
        mtdquantidade(op){
            if (parseInt(op) === 1){
                this.qtditemedicao++;
            }else{
                if (parseFloat(this.qtditemedicao) > 1){
                    this.qtditemedicao--;
                }
            }
        },
        mtdtabelasprodutos(idproduto){
            let vself       = this;
            let loader      = vself.$loading.show();
            let parametros  = [
                {parametro: 'op',           valor : 'tabelasprodutove'},
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                {parametro: 'idproduto',    valor : idproduto}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
            retorno.then(function (response) {
                loader.hide();
                vself.lsttabelasproduto       = response.data;                                
                vself.idtabelaprodutoedicao   = vself.vidtabela;
                let i = util.getArrayIndexForKey(vself.lsttabelasproduto, 'id', vself.vidtabela);
                if (i < 0){
                    if (vself.lsttabelasproduto.length > 0){                        
                        i = 0;
                        vself.idtabelaprodutoedicao   = vself.lsttabelasproduto[i].id;
                    }
                }
                vself.vlunitarioedicao        = vself.lsttabelasproduto[i].prtabela;
                vself.tipodescacresedicao     = 0;
                vself.fatordescontoitemedicao = 0;
                vself.permitedescontove       = vself.lsttabelasproduto[i].permitedescontove;                
            }).catch(function (response) {
                vself.lsttabelasproduto  = [];
                loader.hide();
            });				
        },
        mtdselecionaprecotabela(){
           let i = util.getArrayIndexForKey(this.lsttabelasproduto, 'id', this.idtabelaprodutoedicao);
           this.vlunitarioedicao        = this.lsttabelasproduto[i].prtabela;
           this.tipodescacresedicao     = 0;
           this.fatordescontoitemedicao = 0;
           this.permitedescontove       = this.lsttabelasproduto[i].permitedescontove;

        },
        mtdcalculatotalitem(){
            if (parseInt(this.tipodescacresedicao) === 0){
                let desconto = parseFloat(this.qtditemedicao) * parseFloat(this.vlunitarioedicao) * parseFloat(this.fatordescontoitemedicao) / 100;
                this.vltotalitemedicao = (parseFloat(this.qtditemedicao) * parseFloat(this.vlunitarioedicao)) - desconto;
            }else{
                this.vltotalitemedicao = (parseFloat(this.qtditemedicao) * parseFloat(this.vlunitarioedicao)) - parseFloat(this.fatordescontoitemedicao);
            }
        },
        mtdadcionaritem(){
            if (this.vidfilial === null){
                this.$toastr.w('Filial deve ser informada!', 'Atenção!');
                return;
            }            
            if (this.vidcliente === null){
                this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
                return;
            }
            if (this.vidplano === null){
                this.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
                return;
            }
            this.mtdrotinaprodutos();
        },        
        mtdrotinaalteraritem(item){
            var vself       = this;
            let loader      = vself.$loading.show();
            let parametros  = [
                {parametro: 'op',               valor : 'listagem'},
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'filtro',           valor : ''},
                {parametro: 'coddig',           valor : item.idproduto},
                {parametro: 'limit',            valor : 1},
                {parametro: 'offset',           valor : 0},
                {parametro: 'idusuariove',      valor : vself.$store.state.usuario.id}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                loader.hide();						
                if (response.data.length > 0){
                    let produto = response.data[0];
                    vself.opitem = 2;

                    vself.vltotal_old_edicao		= item.vltotal;//variável para estornar o valor anterior                    
                    vself.itemalteracao			    = item.item;
                    vself.qtditemedicao             = item.qtditem;
                    vself.idprodutoedicao           = item.idproduto;
                    vself.descricaoprodutoedicao    = item.descproduto;
                    vself.descmarcaedicao           = produto.descmarca;
                    vself.undprodutoedicao		    = produto.und;
                    vself.observacoesprodutoedicao  = produto.observacoes;
                    vself.idtabelaprodutoedicao     = item.idtabela;
                    vself.vlunitarioedicao          = item.vlunitario;
                    vself.vltotalitemedicao         = item.vltotal;
                    vself.fracionadoedicao          = produto.fracionado;
                    vself.referenciaprodutoedicao   = produto.referencia;

                    vself.lsttabelasproduto         = []; 
                    for (let i = 0; i < produto.tabelas.length; i++) {
                        let tbtmp = {
                            id        : produto.tabelas[i].idtabela,
                            descricao : produto.tabelas[i].desctabela,
                            prtabela  : produto.tabelas[i].prtabela,
                            permitedescontove : produto.tabelas[i].permitedescontove
                        }                            
                        vself.lsttabelasproduto.push(tbtmp);                                            
                    }
                    
                    let i = util.getArrayIndexForKey(vself.lsttabelasproduto, 'id', item.idtabela);
                    //vself.vlunitarioedicao        = vself.lsttabelasproduto[i].prtabela;                    

                    vself.tipodescacresedicao     = item.tipodescacres;
                    vself.fatordescontoitemedicao = item.valordescacres;                    

                    $('#mdedicaoitemve').modal('show');                         
                }
            }).catch(function (response) {
                vself.$toastr.w('Problemas ao tentar carregar informações do item!', 'Atenção!');
                loader.hide();
            });
        },        
        mtdgravaritem(){
            let vself = this;            
            if (parseFloat(this.qtditemedicao) <= 0){
                this.$toastr.w('Quantidade inválida!', 'Atenção!');
                $('#edqtditemedicao').focus();
                return;
            }
            if (this.idtabelaprodutoedicao === ''){
                this.$toastr.w('Selecione uma tabela de preço!', 'Atenção!');
                $('#cbtabelasproduto').focus();
                return;
            }                                    
            if (parseFloat(this.vlunitarioedicao) <= 0){
                this.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
                $('#edvlunitarioedicao').focus();
                return;
            }
            if (parseInt(this.fracionadoedicao) === 0){
                if (!Number.isInteger(this.qtditemedicao)){
                    this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
                    $('#edqtditemedicao').focus();
                    return;
                }
            }

            let fatd = 0;
            if (parseInt(this.tipodescacresedicao) === 0){
                fatd = this.fatordescontoitemedicao;
            }else{
                fatd = parseFloat(this.fatordescontoitemedicao) / (parseFloat(this.qtditemedicao) * parseFloat(this.vlunitarioedicao)) * 100;
            }
            if (parseFloat(fatd) > parseFloat(this.$store.state.usuario.descontoprodutos)){
                this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
                $('#cbtipodescacresedicao').focus();					
                return;
            }					

            if (parseInt(this.opitem) === 1){
                if (util.findValInArray(this.lstitens, 'idproduto', this.idprodutoedicao)){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'O ítem já está incluso no pedido. Deseja continuar e adicioná-lo novamente?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    vself.item++;
                                    let itemtmp = {
                                        idproduto		: vself.idprodutoedicao,
                                        descproduto		: vself.descricaoprodutoedicao,
                                        coddig			: vself.idprodutoedicao,
                                        item			: vself.item,
                                        qtditem			: vself.qtditemedicao,
                                        unditem			: vself.undprodutoedicao,
                                        idtabela        : vself.idtabelaprodutoedicao,
                                        desctabela      : $('#cbtabelasproduto :selected').text(),
                                        permitedescontove : vself.permitedescontove,
                                        vlunitario		: vself.vlunitarioedicao,
                                        descacres		: 0,
                                        tipodescacres	: vself.tipodescacresedicao,
                                        valordescacres	: vself.fatordescontoitemedicao,
                                        manipulaval		: 0,
                                        vltotal			: vself.vltotalitemedicao,
                                        idestoque		: vself.$store.state.filialpadrao.idestoque,
                                        descestoque		: vself.$store.state.filialpadrao.descestoque,
                                        infadprod		: '',
                                        qtdentregar		: vself.qtditemedicao,
                                        idtecnicosolicita   : 0,
                                        nometecnicosolicita : ''
                                    };
                                    vself.totalprodutos = vself.totalprodutos + parseFloat(vself.vltotalitemedicao);

                                    vself.lstitens.push(itemtmp);

                                    vself.totalgeral	= vself.totalprodutos;

                                    vself.mtdlimpaedicaoitem();
                                    $('#mdedicaoitemve').modal('hide');						                                   
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    $('#edqtdenviar').focus();
                                    return;
                                }
                            }
                        }
                    });						
                }else{					
                    vself.item++;
                    let itemtmp = {
                        idproduto		: vself.idprodutoedicao,
                        descproduto		: vself.descricaoprodutoedicao,
                        coddig			: vself.idprodutoedicao,
                        item			: vself.item,
                        qtditem			: vself.qtditemedicao,
                        unditem			: vself.undprodutoedicao,
                        idtabela        : vself.idtabelaprodutoedicao,
                        desctabela      : $('#cbtabelasproduto :selected').text(),
                        permitedescontove : vself.permitedescontove,
                        vlunitario		: vself.vlunitarioedicao,
                        descacres		: 0,
                        tipodescacres	: vself.tipodescacresedicao,
                        valordescacres	: vself.fatordescontoitemedicao,
                        manipulaval		: 0,
                        vltotal			: vself.vltotalitemedicao,
                        idestoque		: vself.$store.state.filialpadrao.idestoque,
                        descestoque		: vself.$store.state.filialpadrao.descestoque,
                        infadprod		: '',
                        qtdentregar		: vself.qtditemedicao,
                        idtecnicosolicita   : 0,
                        nometecnicosolicita : ''
                    };
                    vself.totalprodutos = vself.totalprodutos + parseFloat(vself.vltotalitemedicao);

                    vself.lstitens.push(itemtmp);
                    vself.totalgeral	= vself.totalprodutos;
                    vself.mtdlimpaedicaoitem();
                    $('#mdedicaoitemve').modal('hide');							
                }	
            }else{
                vself.totalprodutos = vself.totalprodutos - parseFloat(vself.vltotal_old_edicao);

                let indiceitem 						= util.getArrayIndexForKey(vself.lstitens, 'item', vself.itemalteracao)
                let lsttmp 							= vself.lstitens;
                vself.lstitens						= [];

                lsttmp[indiceitem].descproduto		= vself.descricaoprodutoedicao;
                lsttmp[indiceitem].qtditem			= vself.qtditemedicao;
                lsttmp[indiceitem].unditem			= vself.undprodutoedicao;
                lsttmp[indiceitem].idtabela         = vself.idtabelaprodutoedicao,
                lsttmp[indiceitem].desctabela       = $('#cbtabelasproduto :selected').text();
                lsttmp[indiceitem].vlunitario		= vself.vlunitarioedicao;
                lsttmp[indiceitem].permitedescontove = vself.permitedescontove;
                lsttmp[indiceitem].descacres		= 0;
                lsttmp[indiceitem].tipodescacres	= vself.tipodescacresedicao;
                lsttmp[indiceitem].valordescacres	= vself.fatordescontoitemedicao;
                lsttmp[indiceitem].manipulaval		= 0;
                lsttmp[indiceitem].vltotal			= vself.vltotalitemedicao;
                lsttmp[indiceitem].idestoque		= vself.$store.state.filialpadrao.idestoque;
                lsttmp[indiceitem].descestoque		= vself.$store.state.filialpadrao.descestoque;					
                lsttmp[indiceitem].infadprod		= '';
                lsttmp[indiceitem].qtdentregar		= vself.qtditemedicao;
                lsttmp[indiceitem].idtecnicosolicita   = 0,
                lsttmp[indiceitem].nometecnicosolicita = '';


                vself.totalprodutos 				= vself.totalprodutos + parseFloat(vself.vltotalitemedicao);

                vself.lstitens 						= lsttmp;
                vself.vltotal_old_edicao			= 0;
                vself.totalgeral					=  vself.totalprodutos;
                $('#mdedicaoitemve').modal('hide');
            }				
        },
        mtdexcluiritem(item){		
            let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item);
            this.totalprodutos  = this.totalprodutos - parseFloat(this.lstitens[indiceitem].vltotal);

            this.totalgeral	    =  this.totalprodutos;

            this.lstitens.splice(indiceitem, 1);
        },        
        mtdaplicardesconto(){
            if (this.lstitens.length === 0){
                this.$toastr.i('Não há itens para lançamento do desconto!', 'Informação!');
            }else{
                this.tipodesctotal		 = 0;
                this.fatordescontototal  = 0;
                this.totalsemdesconto    = 0;
                this.resdesconto		 = 0;
                for (let item of this.lstitens) {
                    if (parseInt(item.permitedescontove) === 0){
                        this.$toastr.i('Existem alguns itens que não são permitidos descontos. Favor aplicar individualmente!', 'Informação!');
                        return;
                    }
                    this.totalsemdesconto = this.totalsemdesconto + (item.vlunitario * item.qtditem);
                }
                this.totalcomdesconto	  = this.totalsemdesconto;
                $('#mdaplicardesconto').modal('show');
            }
        },
        mtdconfirmaaplicacaodesconto(){				
            let fatoraplicar 		= 0;
            
            if (parseInt(this.tipodesctotal)){
                fatoraplicar = this.resdesconto;					
            }else{
                fatoraplicar = this.fatordescontototal;
            }

            if (parseFloat(fatoraplicar) > parseFloat(this.$store.state.usuario.descontoprodutos)){
                this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
                $('#cbtipodesctotal').focus();					
                return;
            }

            if (fatoraplicar < 0){
                this.$toastr.w('Desconto inválido!', 'Informação!');
                $('#edfatordescontototal').focus();
                return;
            }

            if (fatoraplicar > 0){
                for (let item of this.lstitens) {
                    if (((item.vlunitario * item.qtditem) * fatoraplicar / 100) < 0.01){
                        this.$toastr.i('Desconto não pode ser divido pela quantidade total de itens do pedido. '+
                                        'A divisão do desconto fica abaixo de 0,01 centavo. Tente o desconto individual', 'Informação!');
                        return;
                    }
                }
            }

            this.totalgeral		    = this.totalgeral - this.totalprodutos;				
            this.totalprodutos		= 0;
            let descacumulado 		= 0;
            for (var i = 0; i < this.lstitens.length; i++) {
                let vldesconto 			= (this.lstitens[i].vlunitario * this.lstitens[i].qtditem) * fatoraplicar / 100;
                
                if (vldesconto < 0.01){
                    descacumulado = vldesconto;
                }else{
                    descacumulado = 0;
                }

                vldesconto 			= util.arredondaValores(vldesconto, 2, 'round');
                if (vldesconto >= 0.01){
                    this.lstitens[i].descacres		= 0;
                    this.lstitens[i].tipodescacres	= 1;
                    this.lstitens[i].valordescacres	= vldesconto + descacumulado;
                    descacumulado = 0;
                    this.lstitens[i].vltotal		= util.arredondaValores((this.lstitens[i].vlunitario * this.lstitens[i].qtditem) - vldesconto, 2, 'round');
                }else{
                    this.lstitens[i].valordescacres	= 0;
                    this.lstitens[i].vltotal		= util.arredondaValores(this.lstitens[i].vlunitario * this.lstitens[i].qtditem, 2, 'round');
                }                    
                this.totalprodutos = this.totalprodutos + this.lstitens[i].vltotal;                
            }

            this.totalprodutos 	= util.arredondaValores(this.totalprodutos, 2, 'round');

            this.totalgeral		= this.totalgeral + this.totalprodutos;	
            
            let vlajuste = 0;
            let ajustar  = 0;
            if (this.totalcomdesconto > this.totalprodutos){
                vlajuste = this.totalcomdesconto - this.totalprodutos;
                ajustar  = 1;//ajuste para menos
            }else{
                vlajuste = this.totalprodutos - this.totalcomdesconto;
                ajustar  = 0;//ajuste para mais
            }
            if (vlajuste > 0 && vlajuste < 0.01){
                vlajuste = 0.01;
            }
            if (vlajuste > 0){
                for (var x = 0; x < this.lstitens.length; x++) {
                    if (parseFloat(this.lstitens[x].vltotal) > vlajuste){
                        //console.log(this.lstitens[x].valordescacres);
                        if (ajustar === 0){//ajuste para mais
                            this.lstitens[x].valordescacres	= util.arredondaValores(this.lstitens[x].valordescacres + vlajuste, 2, 'round');
                        }else{//ajuste
                            this.lstitens[x].valordescacres	= util.arredondaValores(this.lstitens[x].valordescacres - vlajuste, 2, 'round');
                        }							
                        if (this.lstitens[x].valordescacres < 0){
                            this.lstitens[x].valordescacres = 0;
                        }
                        this.lstitens[x].vltotal		= (this.lstitens[x].vlunitario * this.lstitens[x].qtditem) - this.lstitens[x].valordescacres;							
                        break;
                    }
                }
                if (parseInt(ajustar) === 0){
                    this.totalprodutos  = this.totalprodutos - vlajuste;
                    this.totalgeral	    = this.totalgeral    - vlajuste;
                }else{
                    this.totalprodutos  = this.totalprodutos + vlajuste;
                    this.totalgeral	    = this.totalgeral    + vlajuste;						
                }					
            }		
            $('#mdaplicardesconto').modal('hide');
        },
        mtdgravar(){
            let vself 			= this;
            let temprecozerado = false;

            if (vself.lstitens.length === 0){
                vself.$toastr.w('Impossível finalizar pedido sem itens!', 'Atenção!');
                return;
            }

            for (let item of vself.lstitens) {
                if (parseFloat(item.vlunitario) <= 0){
                    temprecozerado = true;
                    break;
                }
            }
            if (temprecozerado){
                vself.$toastr.w('Existe(m) algum(ns) ítem(ns) com preço menou ou igual a zero. Verifique e tente novamente!', 'Atenção!');
                return;
            }
            $.confirm({
                title: 'Confirmação!',
                content: 'Deseja mesmo salvar o pedido?',
                icon: 'fa fa-question-circle',
                escapeKey: true,
                backgroundDismiss: false,
                escapeKey: 'nao',
                type: 'dark',
                typeAnimated: true,
                buttons: {
                    sim: {
                        text: '<u>S</u>im',
                        keys: ['s', 'S'],
                        btnClass: 'btn-blue',
                        action: function () {
                            $('.btn-blue').prop('disabled', true);
                            vself.mtdregistro();
                        },
                    },
                    nao: {
                        text: '<u>N</u>ão',
                        keys: ['n', 'N'],
                        action: function () {
                        }
                    }
                }
            });
        },
        mtdregistro(){
            let vself  = this;
            let loader = vself.$loading.show();
            let registrocrud = {
                'id'                : this.vid,
                'idfilial'          : this.vidfilial,
                'idcliente'			: this.vidcliente,
                'idvendedor'		: this.vidvendedor,
                'tipo'				: 0,
                'dtemissao'			: this.mtdformatadatagravar(this.vdtemissao),
                'idplano'			: this.vidplano,
                'totalprodutos'		: this.totalprodutos,
                'totalservicos'		: 0,
                'identificador'		: '',
                'objeto'			: '',
                'marcacao'			: '',
                'nrserie'			: '',
                'marca'				: '',
                'modelo'			: '',
                'responsavel'		: '',
                'fone'				: '',
                'defeitoapresentado': '',
                'acessorios'		: '',
                'outrasinformacoes'	: '',
                'observacoes'		: this.vobservacoes,
                'totalgeral'		: this.totalgeral,
                'stpedido'			: 0,
                'dtfatura'			: '',
                'reservar'			: this.vreservar === false ? 0 : 1,
                'entregaexterna'	: this.ventregaexterna === false ? 0 : 1,
                'origem'			: 4,
                'pathimagens'       : '', 
                'itens'				: this.lstitens,
                'servicos'			: []
            };
            let faturarsemsaldo = util.opcaousuario('020Z.030Z.120Z', vself.$store.state.perfilusuario) === false ? 0 : 1;
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'rotinacrud'},
                {parametro: 'opcrud',           valor : vself.opcrud},
                {parametro: 'registro',         valor : JSON.stringify(registrocrud)},
                {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                {parametro: 'straleatoria',     valor : vself.sringaleatoria},
                {parametro: 'codop',            valor : parseInt(this.opcrud) === 1 ? '020Z.030Z.070Z' : parseInt(this.opcrud) === 2 ? '020Z.030Z.080Z' : '020Z.030Z.090Z'},
                {parametro: 'faturarsemsaldo',	valor : faturarsemsaldo}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data.inf)){
                    vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                    vself.psituacao     	= 0;
                    vself.pfiltroperiodove  = 0;
                    vself.pidpedido     	= parseInt(vself.opcrud) === 1 ? response.data.inf : vself.vid;
                    vself.vendaativa        = false;
                    $('#dv-venda-ativa').hide();            
                    $('#dv-listagempedidos').fadeIn(700);
                    vself.mtdexecutapesquisaped();

                }else{
                    let tpret = response.data.inf.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                            break;
                    }
                }
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
            });
        },
        mtdmostrarmenu(pedido){				
            this.pedidomenu = JSON.parse(JSON.stringify(pedido));
            $('#mdmenupedido').modal('show');
        },
        mtdmenucliente(cliente){
            this.clientemenu = cliente;
            $('#mdmenucliente').modal('show');
        },
        mtdalterar(pedido){
            $('#mdmenupedido').modal('hide');
            if (!util.opcaousuario('020Z.030Z.080Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {						
                this.mtdlocalizaregistro(pedido.id);
            }
        },
        mtdlocalizaregistro(id){
            var vself       = this;
            let loader      = vself.$loading.show();
            let filtro      = ' and p.id='+id;
            let parametros  = [
                {parametro: 'op',           valor : 'listagem'},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'filtro',       valor : filtro},
                {parametro: 'limit',        valor : 1},
                {parametro: 'offset',       valor : 0},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                loader.hide();
                if (!vself.clonar){	
                    if (parseInt(response.data.pedidos[0].stpedido) !== 0){
                        vself.$toastr.i('Para EDITAR ou REMOVER o pedido, a situação do mesmo deve estar em aberto!', 'Informação!');
                        return;
                    }
                    if (parseInt(response.data.pedidos[0].liberarpdv) === 1){
                        vself.$toastr.i('Para EDITAR ou REMOVER o pedido, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
                        return;
                    }	
                }else{
                    vself.clonar = false;
                }				

                vself.mtdigualarcampos(response.data.pedidos[0]);	

            }).catch(function (response) {
                loader.hide();
            });
        },
        mtdigualarcampos(registro){
            this.vid                = registro.id;
            this.vidcliente			= registro.idcliente;
            this.vnomecliente		= registro.nomecliente;
            this.vidvendedor        = registro.idvendedor;
            //this.vtipo				= registro.tipo;
            this.vdtemissao			= registro.dtemissao;
            this.totalprodutos		= registro.totalprodutos;
            //this.vtotalservicos		= registro.totalservicos;
            //this.videntificador		= registro.identificador;
            //this.vobjeto			= registro.objeto;
            //this.vmarcacao			= registro.marcacao;
            //this.vnrserie			= registro.nrserie;
            //this.vmarca				= registro.marca;
            //this.vmodelo			= registro.modelo;
            //this.vresponsavel		= registro.responsavel;
            //this.vfone				= registro.fone;
            //this.vdefeitoapresentado= registro.defeitoapresentado;
            //this.vacessorios		= registro.acessorios;
            //this.voutrasinformacoes	= registro.outrasinformacoes;
            this.vobservacoes		= registro.observacoes;
            this.totalgeral		    = registro.totalgeral;
            //this.vstpedido			= registro.stpedido;
            //this.vdtfatura			= registro.dtfatura;
            this.vreservar			= parseInt(registro.reservar) === 0 ? false : true;
            this.ventregaexterna	= parseInt(registro.entregaexterna) === 0 ? false : true;
            //this.vorigem			= registro.origem;
            //this.vpathimagens       = registro.pathimagens !== '' ? registro.pathimagens : util.GerarStringAleatoria();				
            //this.lstservicos		= registro.servicos;
            //this.lstImagens         = registro.imagens;			

            this.item				= registro.itens.length === 0 ? 0 : registro.itens[registro.itens.length - 1].item;

            var deffilial  = new Option(registro.fantasia, registro.idfilial, true, true);
            $('#cbfilial').append(deffilial).trigger('change');

            this.vidplano			= registro.idplano;
            this.vtipoplano			= registro.tipoplano;
            this.vdescplano			= registro.descplano;
            this.vidtabela			= registro.idtabela;

            setTimeout(() => {
                this.lstitens			= registro.itens;

                this.vendaativa   = true;
                this.opcrud       = 2;
                $('.nav-tabs a[href="#dvitens"]').tab('show');			
                $('#dv-listagempedidos').hide();            
                $('#dv-venda-ativa').fadeIn(700);                
            }, 300);
        },                			
        mtdrotinapdv(idpedido){
            $('#mdmenupedido').modal('hide');
            if (!util.opcaousuario('020Z.030Z.100Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else{
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinapdv'},
                    {parametro: 'idpedido',     valor : idpedido},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.030Z.100Z'},
                    {parametro: 'opconf',       valor : util.opcaousuario('020Z.010Z.036Z', vself.$store.state.perfilusuario) ? 1 : 0},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Solicitação realizada com sucesso!', 'Informação!');
                        vself.psituacao     	= 3;
                        vself.pqtd_paginas  	= 1;
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            }				
        },        
        mtdimprimirpedido(idpedido, tp){				
            $('#mdmenupedido').modal('hide');
            if (!util.opcaousuario('020Z.030Z.110Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else{            
                window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
                            this.$store.state.filialpadrao.idcliente+
                            '&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
                            this.$store.state.usuario.id, '_blank');				
            }
        },
        mtdimprimirguiaseparacao(idpedido, tp){				
            $('#mdmenupedido').modal('hide');
            if (!util.opcaousuario('020Z.030Z.115Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else{              
                window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirguiaseparacao.php?idclientesac='+
                            this.$store.state.filialpadrao.idcliente+
                            '&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
                            this.$store.state.usuario.id, '_blank');				
            }            
        },
        mtdcarregatituloscliente(){
            var vself               = this; 
            vself.lsttituloscliente = [];                   
            vself.vrVencidos        = 0;
            vself.vrAvencer         = 0;
            vself.vrJuros           = 0;
            vself.vrMulta           = 0;
            vself.vrTotal           = 0;                            
            let loader              = this.$loading.show();
            let filtro 		        = 'and t.idcliente='+vself.clientemenu.id+' and t.inativo=0 and t.sttit in ("A", "P")';//abertos
            let parametros  = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'listagem'},
                {parametro: 'situacao',     valor : 0},//0 - Abertos, 1 - Baixados
                {parametro: 'ordem',        valor : 2}, 
                {parametro: 'dtbasecalculo',valor : util.InverterData(util.DataAtual(true))},                                                
                {parametro: 'filtro',       valor : filtro},
                {parametro: 'limit',        valor : '99999999999'},
                {parametro: 'offset',       valor : 0}
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtitulosreceber.php');
            retorno.then(function (response) {
                vself.lsttituloscliente = response.data.lista;
                //iguala totais dos titulos para calcular os selecionados
                vself.vrVencidos        = response.data.vencidos;
                vself.vrAvencer         = response.data.avencer;
                vself.vrJuros           = response.data.totjuros;
                vself.vrMulta           = response.data.totmulta;
                vself.vrTotal           = response.data.totgeral;

                loader.hide();
            }).catch(function (response) {
                vself.lsttituloscliente = [];
                vself.vrVencidos        = 0;
                vself.vrAvencer         = 0;
                vself.vrJuros           = 0;
                vself.vrMulta           = 0;
                vself.vrTotal           = 0;                
                loader.hide();
            });
        },
        mtdfinanceirocliente(){
            if (!util.opcaousuario('020Z.030Z.030Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {            
                $('#mdfinanceirocliente').modal('show'); 
            }
        },
        mtdhistoricocompraprodutos(){  
            if (!util.opcaousuario('020Z.030Z.040Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {                                  
                $('#mdprodutoscliente').modal('show'); 
            }
        },
        mtdcarregaprodutoscliente(){
            let vself       = this;
            vself.lstprodutoscliente  = [];
            vself.totalfaturadocliente= 0;            
            let loader      = vself.$loading.show();
            let parametros  = [
                {parametro: 'op',           valor : 'produtosclienteve'},
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'idcliente',    valor : vself.clientemenu.id}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
            retorno.then(function (response) {
                loader.hide();
                vself.lstprodutoscliente  = response.data.itens;
                vself.totalfaturadocliente= response.data.totalfaturado;
            }).catch(function (response) {
                vself.lstprodutoscliente  = [];
                vself.totalfaturadocliente= 0;
                loader.hide();
            });				       
        },
        mtdgerarimagens(imagens){
            this.images = [];
            for (let i = 0; i < imagens.length; i++) {
                this.images.push(this.$store.state.configpaths.pathimagens + imagens[i].patharquivo);                    
            }
            this.$viewerApi({                   
                images: this.images,
            });
        },        
        mtdvisualizarimagens(produto){
            if (produto.imagens.length > 0){
                this.produtoviewimg = [];
                this.produtoviewimg = produto;
                this.mtdgerarimagens(this.produtoviewimg.imagens);                            
            }else{
                this.$toastr.i('Não há imagens disponíveis para visualização!', 'Informação!');
            }
        },
        mtdvisualizarestoque(produto){
            this.idprodutoestoque   = produto.id;
            this.descproestoque     = produto.descricao;
            $('#mdestoqueproduto').modal('show');
        },
        mtdquestionaexclusaopedido(pedido){
            $('#mdmenupedido').modal('hide');
            let vself = this;            
            if (!util.opcaousuario('020Z.030Z.090Z', this.$store.state.perfilusuario)){
                this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
            }else {      
                let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+pedido.id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (!vself.clonar){	
                        if (parseInt(response.data.pedidos[0].stpedido) !== 0){
                            vself.$toastr.i('Para EDITAR ou REMOVER o pedido, a situação do mesmo deve estar em aberto!', 'Informação!');
                            return;
                        }
                        if (parseInt(response.data.pedidos[0].liberarpdv) === 1){
                            vself.$toastr.i('Para EDITAR ou REMOVER o pedido, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
                            return;
                        }	
                    }else{
                        vself.clonar = false;
                    }				

                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja mesmo REMOVER o pedido?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: function () {
                                    $('.btn-blue').prop('disabled', true);
                                    vself.mtdexcluirpedido(pedido);
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                }
                            }
                        }
                    });        

                }).catch(function (response) {
                    loader.hide();
                });                                        
            }
        },
        mtdexcluirpedido(pedido){
            let vself  = this;
            let loader = vself.$loading.show();
            let registrocrud = {
                'id'                : pedido.id,
                'idfilial'          : pedido.idfilial,
                'idcliente'			: pedido.idcliente,
                'idvendedor'		: pedido.idvendedor,
                'tipo'				: 0,
                'dtemissao'			: vself.mtdformatadatagravar(pedido.dtemissao),
                'idplano'			: pedido.idplano,
                'totalprodutos'		: pedido.totalprodutos,
                'totalservicos'		: 0,
                'identificador'		: '',
                'objeto'			: '',
                'marcacao'			: '',
                'nrserie'			: '',
                'marca'				: '',
                'modelo'			: '',
                'responsavel'		: '',
                'fone'				: '',
                'defeitoapresentado': '',
                'acessorios'		: '',
                'outrasinformacoes'	: '',
                'observacoes'		: pedido.observacoes,
                'totalgeral'		: pedido.totalgeral,
                'stpedido'			: 0,
                'dtfatura'			: '',
                'reservar'			: 0,
                'entregaexterna'	: pedido.entregaexterna,
                'origem'			: 4,
                'pathimagens'       : '', 
                'itens'				: pedido.lstitens,
                'servicos'			: []
            };            
            let parametros      = [
                {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'rotinacrud'},
                {parametro: 'opcrud',           valor : 3},
                {parametro: 'registro',         valor : JSON.stringify(registrocrud)},
                {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                {parametro: 'straleatoria',     valor : vself.sringaleatoria},
                {parametro: 'codop',            valor : '020Z.030Z.090Z'}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
            retorno.then(function (response) {
                loader.hide();
                if ($.isNumeric(response.data.inf)){
                    vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                    vself.psituacao     	= 0;
                    vself.pfiltroperiodove  = 0;
                    vself.vendaativa        = false;
                    vself.mtdexecutapesquisaped();
                }else{
                    let tpret = response.data.inf.substring(0,1);
                    switch (tpret) {
                        case 'I':
                            vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                            break;
                        case 'E': default:
                            vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                            break;
                    }
                }
            }).catch(function (response) {
                loader.hide();
                vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
            });            
        }        
    },
    mounted: function () {  
        $('[data-toggle="popover"]').popover();  
        if (util.verificasessao(this)) {
            let vself = this;

            let loader = vself.$loading.show();
            let parametros = [
                {parametro: 'op', valor: 'dadosusuario'},
                {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
            retorno.then(function (response) {
                loader.hide();
                vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                if (!util.opcaousuario('020Z.030Z', vself.$store.state.perfilusuario)) {
                    vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    setTimeout(function(){
                        util.gotoprincipal();
                    },1000);
                }else{

                    vself.puvenderitemsemsaldo    = util.opcaousuario('020Z.030Z.120Z', vself.$store.state.perfilusuario);
                    vself.pumanipulartabelasitem  = util.opcaousuario('020Z.030Z.130Z', vself.$store.state.perfilusuario);
                    vself.pumanipulavendedor      = util.opcaousuario('020Z.030Z.065Z', vself.$store.state.perfilusuario);

                    $('#mdmenupedido').on('show.bs.modal', function (e) {
                        $('#dvdefimpressao').collapse('hide');
                        $('#dvdefguiaseparacao').collapse('hide');
                    });	
                    
                    $('#dvdefimpressao').on('shown.bs.collapse', function () {
                        $('#dvdefguiaseparacao').collapse('hide');
                    });
                    $('#dvdefguiaseparacao').on('shown.bs.collapse', function () {
                        $('#dvdefimpressao').collapse('hide');
                    });

                    $('#mdfinanceirocliente').on('shown.bs.modal', function (e) {
                        vself.mtdcarregatituloscliente();
                    });

                    $('#mdprodutoscliente').on('shown.bs.modal', function (e) {
                        vself.mtdcarregaprodutoscliente();
                    });

                    $("#cbclientepesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclientes',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 2,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidclienteve = $("#cbclientepesq").val();
                    });
                    
                    $("#cbmarcapesq").select2({
                            id: function (e) {return e.id},
                            ajax: {
                                url: vself.$store.state.configpaths.pathselect2,
                                dataType: 'json',
                                delay: 250,
                                data: function (params) {
                                    return {
                                        q: params.term,
                                        idclientesac : vself.$store.state.filialpadrao.idcliente,
                                        tb: 'tbmarcas',
                                        c1: 'id',
                                        c2: 'descricao'
                                    };
                                },
                                processResults: function (data) {
                                    return {
                                        results: data
                                    };
                                },
                                cache: true
                            },
                            minimumInputLength: 0,
                            theme: 'bootstrap',
                            language: "pt-BR",
                            templateResult: util.formatResult,
                            templateSelection: util.formatSelection
                        }
                    ).change(function () {
                        vself.pidmarcave = $("#cbmarcapesq").val();
                    });  

                    $("#cbvendedorpesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbvendedores',
                                    c1: 'id',
                                    c2: 'nome'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }).change(function () {
                        vself.pidvendedor = $("#cbvendedorpesq").val();
                    });                    
                    
					var defvendedor  	= new Option(vself.$store.state.usuario.nomevendedor, vself.$store.state.usuario.idvendedor, true, true);
					$('#cbvendedorpesq').append(defvendedor).trigger('change');                    
                }
            }).catch(function (response) {
                loader.hide();
                console.log(response.message);
            });
        }             
    },
    computed:{
        calculadescontototalitens(){
            if (parseInt(this.tipodesctotal) === 0){
                this.totalcomdesconto  = this.totalsemdesconto - (this.totalsemdesconto * this.fatordescontototal / 100);
                this.resdesconto	   = this.fatordescontototal * this.totalsemdesconto / 100;						
            }else{
                this.totalcomdesconto  = this.totalsemdesconto - this.fatordescontototal;			
                this.resdesconto	   = this.fatordescontototal / this.totalsemdesconto * 100;			
            }
        },
        selecionaperiodove() {
            if(parseInt(this.pfiltroperiodove) === 0){
                this.hab_desab_periodove = true;
            }else{
                this.hab_desab_periodove = false;
            }
        }        
    },    
    watch:{
        pagina_atualcpve(val){
            this.mtdcarregaprodutos(val);
        },
        pagina_atualccve(val){
            this.mtdcarregaclientes(val);
        },
        qtditemedicao(){
            this.mtdcalculatotalitem();
        },
        vlunitarioedicao(){
            this.mtdcalculatotalitem();
        },
        tipodescacresedicao(){
            this.mtdcalculatotalitem();
        },
        fatordescontoitemedicao(){
            this.mtdcalculatotalitem();
        }
    }    
}
</script>
<style>
.item-lst-menu-ve{
    cursor: pointer;
    padding: 20px;
}
.icones-menu-ve{
    font-size: 40px;
    color: #666666;
}
.tit-item-menu-ve{
    font-size: 16px;
    color: #666666;
    font-weight: 600;
}
.tit-titulo-cli{
    font-size: 14px;
    color: #666666;
    font-weight: 600;    
}
.sub-tit-item-menu-ve{
    font-size: 12px;
    color: #b7b5b5;    
}
.sub-tit-menu-ve{
    height: 15px;
    font-size: 12px;
    font-weight: 400;
    color: darkgrey;
    margin-top: -8px;
    padding-left: 35px;    
}
.dvhide{
    display: none;
}
.btn-voltar-ve{
    width: 60px;
    position: absolute!important;
    left: 16px!important;
    padding: 0px!important;
    border-radius: 20px!important;    
    height: 27px;
}
#sp-titulove{
    font-weight: 600;
    font-size: 18px;
    color: #666666!important;
}
.spn-item-edicao{
    font-size: 16px;
    color: #666666!important;
    font-weight: 600;
    
}
.btn-op-item-ve{
    font-size: 10px!important;
}
@media screen and (max-width: 991px) {
    .icones-menu-ve{
        margin-top: 8px;
        font-size: 30px;
    }
    .tit-item-menu-ve{
        font-size: 12px;
    }
    .sub-tit-item-menu-ve{
        font-size: 8px;
    }    
    .tit-titulo-cli{
        font-size: 10px;
    }        
} 
</style>